import React, { useEffect } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material'

import { Icon } from './Icon'
import Image from './Image-deprecated'
import { PortableText } from './PortableText'
import { useHeaderHeight } from './Header'

export type AgreementContentProps = {
  max_width: string
  agreement_items: {
    _key: string
    show_divider: boolean
    section_title: string
    section_content: object
    accordian_content: {
      _key: string
      accordian_width: string
      accordian_items: {
        _key: string
        accordian_title: string
        accordian_content: object
        accordian_icon: { asset: { _ref: string, altText: string } }
        open_defaul: boolean
      }[]
    }[]
  }[]
}

export const AgreementContent = ({ ...props }: AgreementContentProps) => {
  const [height] = useHeaderHeight('height')
  useEffect(() => {
    const tempAnchors: Element[] = []
    document.querySelectorAll('main a').forEach(anc => {
      if (anc?.getAttribute('href')?.includes('#')) {
        tempAnchors.push(anc)
      }
    })

    tempAnchors.forEach(a => {
      a.addEventListener(
        'click',
        e => {
          e.preventDefault()
          let href = a.getAttribute('href') || ''
          href = href.substring(href.indexOf('#') + 1, href.length)
          const elem =
            document.getElementById(href) ||
            document.querySelector(`a[name=${href.substring(1, href.length)}]`)
          // gets Element with an id of the link's href
          // or an anchor tag with a name attribute of the href of the link without the #

          if (elem) {
            window.scroll({
              top: elem.offsetTop - height,
              left: 0,
              behavior: 'smooth',
            })
          }
        },
        { passive: true }
      )
    })
  })

  return (
    <Box
      sx={{
        maxWidth: props.max_width,
        pt: { xs: 8.5, laptop: 13 },
        mx: 'auto',
        px: 2,
      }}>
      <Box>
        {props.agreement_items.map((row, idx) => (
          <Box
            key={row._key}
            sx={{
              ...(row.show_divider && {
                borderBottom: 1,
                borderColor: 'border.main',
                py: 3,
              }),
            }}>
            {row.section_title && (
              <Typography
                component={idx === 0 ? 'h1' : 'h2'}
                id={row._key}
                sx={{ fontWeight: 700 }}>
                {row.section_title}
              </Typography>
            )}

            {row.section_content && (
              <PortableText
                blocks={row.section_content}
                trackSectionHeader={row.section_title}
                sxBlock={{
                  h4: { fontSize: 14, fontWeight: 500 },
                  '.MuiTypography-body1': { my: 0.5 },
                }}
              />
            )}

            {row.accordian_content && (
              <Box>
                {row.accordian_content.map(accGroup => (
                  <Box
                    key={accGroup._key}
                    sx={{
                      display: 'grid',
                      gap: 2,
                      gridTemplateColumns: {
                        tablet:
                          accGroup.accordian_width === 'w-1/2'
                            ? 'repeat(2, 1fr)'
                            : 'repeat(1, 1fr)',
                      },
                      overflow: 'hidden',
                      my: 3,
                    }}>
                    {accGroup.accordian_items.map(item => (
                      <Accordion
                        key={item._key}
                        defaultExpanded={item.open_defaul}
                        disableGutters
                        sx={{
                          height: 'fit-content',
                          background: 'none',
                          boxShadow: 'none',
                          border: 1,
                          borderColor: 'border.main',
                          borderRadius: 1,
                          m: 0,
                          '&:before': { content: 'none' },
                        }}>
                        <AccordionSummary
                          expandIcon={
                            <Icon icon='chevron-down' fontSize='12px' />
                          }
                          aria-controls={`${item.accordian_title}-content`}
                          id={`${item.accordian_title}-header`}>
                          <Box sx={{ alignSelf: 'center', img: { width: 20 } }}>
                            <Box component={Image} alt={item.accordian_icon?.asset?.altText} props={item.accordian_icon?.asset?._ref} />
                          </Box>

                          <Typography flex={1} fontWeight={500} mx={2}>
                            {item.accordian_title}
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails sx={{ color: 'text.secondary' }}>
                          <PortableText
                            blocks={item.accordian_content}
                            sxBlock={{
                              h4: { fontSize: 12, fontWeight: 500, mt: 2.3 },
                              '.MuiTypography-body1': { fontSize: 12 },
                            }}
                          />
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
